
<template>
  <div>
    <el-dialog title="查看发货产品清单" :visible.sync="dialogVisible" width="1000px" @open="open">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="invoiceNumber" label="ERP发货单号" align="left" />
        <el-table-column prop="erpOrderNumber" label="订单编号" align="left" />
        <el-table-column prop="porductCode" label="物品代码" align="left" />
        <el-table-column prop="productName" label="产品名称" align="left" />
        <el-table-column prop="number" label="数量" align="left" />
        <el-table-column prop="productUnit" label="单位" align="left" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getDeliveryDetails } from '@/API';

export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisibleDeliver,
      tableData: []
    };
  },
  props: {
    dialogFormVisibleDeliver: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  methods: {
    initData () {
      getDeliveryDetails(this.form.masterContractNum, this.form.invoiceNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.productList;
          this.tableData.forEach((item) => {
            this.$set(item, 'erpOrderNumber', json.data.erpOrderNumber);
          });
          // this.$nextTick(() => {
          // });
        }
      }).catch(() => {

      });
    },
    // 打开页面调用接口
    open () {
      this.initData();
    }
  },
  watch: {
    dialogFormVisibleDeliver (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  }

};
</script>

<style>

</style>
